import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "govuk-inset-text" }, " Loading payment status... ", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "govuk-heading-xl" }, "Sign in or create an account", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "govuk-inset-text" }, " You need an account to order and view your documents ", -1)
const _hoisted_7 = { class: "govuk-button-group" }
const _hoisted_8 = ["href", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.isAuthenticated)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_router_link, {
            to: { name: 'Login', params: { redirect: 'PayResult' } },
            custom: ""
          }, {
            default: _withCtx(({ href, navigate }) => [
              _createElementVNode("a", {
                href: href,
                onClick: navigate,
                role: "button",
                draggable: "false",
                class: "govuk-button",
                "data-module": "govuk-button"
              }, " Sign in ", 8, _hoisted_8)
            ]),
            _: 1
          })
        ])
      ]))
}